// @flow
import React, { Component } from 'react'
import AssignmentFormContainer from './AdvertisementTemplatePage/AssignmentFormContainer'
import EditFormContainer from './AdvertisementTemplatePage/EditFormContainer'
import styled, { type StyledComponent } from 'styled-components'
import AudiencesSelectorContainer from './AdvertisementTemplatePage/AudiencesSelectorContainer'
import PrimaryButton from './controls/PrimaryButton'
import type { Configs } from './types'

const Option: StyledComponent<Object, any, any> = styled.div`
  font-size: 18px;
  font-weight: bold;
  padding: 20px 0 10px;
`
const Wrapper: StyledComponent<Object, any, any> = styled.div`
  max-width: 675px;
`
const TopButton: any = styled(PrimaryButton)`
  margin-left: 14px;
`

type Props = {|
  action: 'copy' | 'update' | 'create',
  configs: Configs,
  editFormCopyPath: string,
  hideAssignmentForm: boolean,
  hideEditForm: boolean,
  onInit: () => void
|}

const t = {
  select_title: 'Назначение шаблонов',
  new_title: 'Создание нового шаблона',
  edit_title: 'Редактирование шаблона объявления',
  copy_title: 'Копирование шаблона объявления',
  copy_button: 'Скопировать шаблон',
  select_audiences: 'Выберите аудитории',
  select_templates: 'Выберите из существующих шаблонов',
  create_new_template: 'или создайте новый шаблон'
}

export default class AdvertisementTemplatePage extends Component<Props> {
  constructor(props: Props) {
    super(props)

    this.props.onInit()
    window.advertisementTemplatePage = this // for tests
  }

  render() {
    const { action } = this.props

    return (
      <div>
        <div className="top-info">
          <h1>{this.pageTitle()}</h1>
          {action === 'update' && (
            <TopButton small href={this.props.editFormCopyPath} beforeContent="+">
              {t.copy_button}
            </TopButton>
          )}
        </div>
        {!this.props.hideAssignmentForm && (
          <Wrapper>
            <Option>{t.select_audiences}</Option>
            <AudiencesSelectorContainer hideHeader />
            <Option>{t.select_templates}</Option>
            <AssignmentFormContainer />
            {action === 'create' && !this.props.hideEditForm && (
              <Option>{t.create_new_template}</Option>
            )}
          </Wrapper>
        )}

        {!this.props.hideEditForm && (
          <EditFormContainer
            configs={this.props.configs}
            action={this.props.action}
            hideAudiences={!this.props.hideAssignmentForm}
          />
        )}
      </div>
    )
  }

  pageTitle() {
    const { action } = this.props
    if (action === 'create') {
      return this.props.hideAssignmentForm ? t.new_title : t.select_title
    } else if (action === 'update') {
      return t.edit_title
    } else {
      return t.copy_title
    }
  }
}
